import api from './api';

/**
 * POST /api/device-tokens — register FCM token for push.
 */
export const registerDeviceToken = async ({
  token,
  platform = 'web',
  deviceName,
  appVersion,
}) => {
  const response = await api.post('/device-tokens', {
    token,
    platform,
    device_name: deviceName || navigator.userAgent.slice(0, 120),
    app_version: appVersion || process.env.REACT_APP_VERSION || 'web',
  });
  return response.data;
};

/**
 * DELETE /api/device-tokens — unregister FCM token (logout / rotation).
 */
export const unregisterDeviceToken = async (token) => {
  if (!token) return null;
  const response = await api.delete('/device-tokens', {
    data: { token },
  });
  return response.data;
};
